export default __webpack_public_path__ + "static/13-402ec3b487e6e2304c637026691975b2.webp";